import { Component, Host, h, Event, EventEmitter, Prop, Listen } from '@stencil/core';
import { LaunchButtonTranslations } from '../../globals/translations';

@Component({
  tag: 'pc-launch-button',
  styleUrl: 'pc-launch-button.css',
  shadow: true,
})
export class PcLaunchButton {
  showError = false; // Set the boolean to true to show the error message
  label = 'Lease with Progressive';
  errorMessage = 'An error occurred loading Progressive. Please try again';

  @Prop({ mutable: true }) loading: boolean;
  @Prop({ mutable: true }) translation: Partial<LaunchButtonTranslations>;

  @Event({ bubbles: true, composed: true }) launchButtonClick: EventEmitter<string>;

  componentWillLoad() {
    this.translation = {
      label: this.label,
      errorMessage: this.errorMessage,
      ...this.translation,
    };
  }

  @Listen('pcFailure', { target: 'body' })
  handlePcFailure() {
    this.showError = true;
  }
  @Listen('pcSuccess', { target: 'body' })
  @Listen('pcCancel', { target: 'body' })
  handlePcSuccessOrCancel() {
    this.showError = false;
  }

  render() {
    return (
      <Host>
        <pc-primary-button
          buttonId="launch-button"
          onClick={() => {
            this.launchButtonClick.emit();
          }}
        >
          {this.loading ? (
            <grit-wc-spinner color="white" />
          ) : (
            <div class="button-text">
              <span>{this.translation.label}</span>
              <grit-wc-prog-logo logo-type="mark-white" logo-width="13" />
            </div>
          )}
        </pc-primary-button>
        {this.showError && (
          <div class="button-error">
            <pc-icon size="20">error_outline</pc-icon>
            {this.translation.errorMessage}.
          </div>
        )}
      </Host>
    );
  }
}
